export default __webpack_public_path__ + "static/media/mask3.7eb1547c.jpeg";